import DeviceCreateForm from './DeviceCreateForm';

export default DeviceCreateForm;
